// extracted by mini-css-extract-plugin
export default {"ribbon":"ImageRibbon-module--ribbon--XBmeJ"};